import { apiKeyClient } from '@better-auth/api-key/client'
import { createAuthClient } from 'better-auth/react'

const isProd = import.meta.env.PROD

type ClientOptions = { plugins: [ReturnType<typeof apiKeyClient>] }

// Explicit annotation required: composite mode can't name the inferred type without
// referencing better-auth's internal path-to-object module (TS2742).
export const authClient: ReturnType<typeof createAuthClient<ClientOptions>> = createAuthClient({
  baseURL: `${isProd ? window.location.origin : import.meta.env.APP_BASE_URL}/api/v1/auth`,
  plugins: [apiKeyClient()],
})
